import { useRef } from 'react';
import { NavMarker } from 'react-rhumb';
import { getApiNamesToShowForBundle } from '../../../constants/merchCards/MerchCardsToShow';
import { withErrorBoundary } from '../../../v2/components/error-boundary/withErrorBoundary';
import { SCREENS } from '../../../v2/constants/tracking/Screens';
import { SUITE_FEATURE_TABLE_HEADER } from '../../../v2/constants/tracking/TrackingSources';
import GenericBundleFeatureTable from './GenericBundleFeatureTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SuiteFeatureTable = ({
  tab
}) => {
  const featureTableRef = useRef(null);
  const featureTableApiNames = getApiNamesToShowForBundle({
    bundleType: 'CRM_SUITE',
    tab
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_FEATURE_TABLE"
    }), /*#__PURE__*/_jsx("div", {
      ref: featureTableRef,
      "data-selenium": "suite-feature-table",
      id: "feature-table",
      children: /*#__PURE__*/_jsx(GenericBundleFeatureTable, {
        screen: SCREENS.SUITE,
        apiNames: featureTableApiNames,
        trackingSource: SUITE_FEATURE_TABLE_HEADER
      })
    })]
  });
};
export default withErrorBoundary(SuiteFeatureTable, {
  fallback: null,
  errorBoundaryName: 'SUITE_FEATURE_TABLE'
});